import type { FaireProductEntity } from "../../entity_types/product";

export const p_c2d9f2cqfq: FaireProductEntity = {
  token: "p_c2d9f2cqfq",
  type: "product",
  name: "Engraved Iron Menorah",
  brandToken: "b_42bfa9c9",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/486dbcb517c96925cc1654430321b10aa54e1c24ed433e179dd53bc214eecc8a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/63c2732c2004e69a6f07dc5acd0efaf6333f459ddca099b385388e4aabe7f504.jpeg",
    "https://cdn.faire.com/fastly/9c3b614b8c5a220e0cdff533c513c1ea31cc5b6d0402d5aaff451afbf9773813.jpeg",
    "https://cdn.faire.com/fastly/85550a7c20f4d5dac29792260fd67bd7a9b8b1ff615b9861bbecea9f9635519e.jpeg",
    "https://cdn.faire.com/fastly/af2cb74272a30c4776c9adf18551aa09e2ef472ca555026acac5b1769e04cd9d.jpeg",
    "https://cdn.faire.com/fastly/c3f0855d0821701ced812e2fa986629ef57e5b7bc1fa63a6a7977ecaf58b7eda.jpeg",
    "https://cdn.faire.com/fastly/47a2fe210a24ed1c38b75641993915064f0254409d74c16f3d470881d8cd9afa.jpeg",
    "https://cdn.faire.com/fastly/4baa08178daca23bff1e737c3a9f0b6c8752708cb06bb6b5339fc74b2c8ae6a5.jpeg",
  ],
  priceDollars: 22.5,
  description:
    "Featuring an antiqued copper‒colored finish and a delicate engraved design, this elegant iron menorah is handcrafted in India. \nIron with antiqued copper‒colored finish - Contains eight candleholders at equal height with the center candleholder raised 0.75 inches higher (for a total of 9 candleholders); Openings for candles: 0.4D (inside diameter) x 0.75H inches; Menorah: 9W (at the widest point) x 11.5H (when measured from the bottom of the base to the top of the center candleholder) inches; Base: 6.25D inches - Handcrafted in India",
  tags: [],
  msrpDollars: 44.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:32.941Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
